/* eslint-disable no-undef */
/**
 *http响应拦截器
 */
 import axios from "axios";
import { Toast } from "vant";
import router from "../router/index"; //路由
 // console.log(router);
 if(process.env.NODE_ENV === 'development'){
   axios.defaults.baseURL = 'http://jhzapi.njjhz.com/';
   //axios.defaults.baseURL = "http://apishop.qushihuo.com/";
   //axios.defaults.baseURL = "http://192.168.10.1681:35100"
   } else {
     axios.defaults.baseURL = config.baseUrl
   }
 ///request拦截器
 axios.interceptors.request.use(
    (req) => {
        const params = router.currentRoute.query;
        // console.log(res)
        req.headers.Authorization = 'token '+params.token;
     req.params = Object.assign({},params,  req.params, {
       t: Math.random(),
     });
     return req;
   },
   (error) => {
     return Promise.reject(error);
   }
 );
 
 //response拦截器
 axios.interceptors.response.use(
   (res) => {
    console.log(typeof res.data)
    if(typeof res.data === "string"){
      return res.data;
    }
     if(res.data.status!=0 && res.data.status!=60002){
       Toast(res.data.message)
       return new Error(res.data.message);
     }else{
       return res.data;
     }
   },
   (error) => {
     return Promise.reject(error); // 返回错误信息
   }
 );
 